import { request } from './client';
import type { QueryParams } from './client';
import type { CampaignProvider, FieldGroup } from '@/types/types';
import type { IFacebookCountry } from '@/types/locationTargeting';

export function fetchCampaignProducts(params: QueryParams = {}) {
  return request('GET', '/v1/account/campaign/products', params);
}

export function listCampaigns(jobId: string, params: QueryParams = {}): Promise<{ data: CampaignProvider[] }> {
  return request('GET', `/v1/account/orders/${jobId}/campaigns`, params);
}

export function getAvailableFields(campaignId: string): Promise<{ groups: FieldGroup[] }> {
  return request('GET', `/v1/account/campaigns/${campaignId}/fields`);
}

export function getInstagramAccounts(
  campaignId: string,
  facebook_page_id: string
): Promise<{ data: { id: string; name: string }[] }> {
  return request('GET', `/v1/account/campaigns/${campaignId}/options/instagram_accounts`, {
    page_id: facebook_page_id,
  });
}

export function getCampaign(campaignId: string): Promise<any> {
  return request('GET', `/v1/account/campaigns/${campaignId}`);
}

export function updateCampaignObject(campaignId: string, object: any): Promise<any> {
  return request('PUT', `/v1/account/campaigns/${campaignId}`, {}, object);
}

export function getAvailableCountries(campaignId: string, query: string): Promise<{ data: IFacebookCountry[] }> {
  return request('GET', `/v1/account/campaigns/${campaignId}/options/targeting_countries`, { query });
}

export function publishCampaigns(orderId: string | number): Promise<any> {
  return request('POST', `/v1/account/order/${orderId}/campaigns/publish`);
}

export async function pollCampaignsStatus(orderId: string | number): Promise<any> {
  const response = await request('GET', `/v1/account/order/${orderId}/campaigns/publishing_status`, {});
  return response.data;
}

export function getCampaignOptions(
  campaignId: string,
  action: string,
  params: QueryParams = {}
): Promise<{ data: any[] }> {
  return request('GET', `/v1/account/campaigns/${campaignId}/options/${action}`, params);
}

export function fetchHelpPages(context: string): Promise<any> {
  return request('GET', `/v1/account/help_pages`, { context });
}
